import type { Config } from "tailwindcss";
import tailwindcssAnimate from "tailwindcss-animate";
// import tailwindClipPath from "tailwind-clip-path";

const uiTailwindConfig: Config = {
  darkMode: ["class"],
  content: [
    "./pages/**/*.{ts,tsx}",
    "./components/**/*.{ts,tsx}",
    "./app/**/*.{ts,tsx}",
    "./src/**/*.{ts,tsx}",
    "../../packages/app-v2/shadcn/**/*.{ts,tsx}",
  ],
  prefix: "",
  theme: {
    container: {
      center: true,
      padding: "2rem",
      screens: {
        "2xl": "1400px",
      },
    },
    extend: {
      zIndex: {
        "100": "100",
        "999": "999",
      },
      clipPath: {
        searchWebPolygon:
          "polygon(0% 0%, 93% 0%, 100% 50%, 100% 100%, 0% 100%)",
        bottomLeftExploreProperties:
          "polygon(0% 0%, 100% 0%, 100% 100%, 19% 100%, 0% 84%)",
        searchMobilePolygon:
          "polygon(0% 0%, 90.2% 0%, 100% 29.4%, 100% 100%, 0% 100%)",
        topLeftPolygon: "polygon(22% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 40%)",
        topRightFourSided: "polygon(0% 0%, 85% 0%,  100% 100%, 0% 100%)",
        topRightFourSidedBlogs: "polygon(0% 0%, 90% 0%,  100% 100%, 0% 100%)",
        bottomLeftAboutUs:
          "polygon(0% 0%, 100% 0%, 100% 100%, 13% 100%, 0% 70%)",
        bottomRightPropertyCountCard:
          "polygon(0% 0%, 100% 0%, 100% 70%, 80% 100%, 0% 100%)",
        bottomRightUpcomingAuctionCard:
          "polygon(0% 0%, 100% 0%, 100% 60%, 90% 100%, 0% 100%)",
        bottomRightPropertyImage:
          "polygon(0% 0%, 100% 0%, 100% 60%, 85% 100%, 0% 100%)",
        bottomRightFooterMobile:
          "polygon(0% 0%, 100% 0%, 100% 85%, 80% 100%, 0% 100%)",
        bottomRightTool: "polygon(0% 0%, 100% 0%, 100% 70%, 93% 100%, 0% 100%)",
        bottomRightPostProperty:
          "polygon(0% 0%, 100% 0%, 100% 68%, 90% 100%, 0% 100%)",
        subAssetText: "polygon(0% 0%, 100% 0%,  85% 100%, 0% 100%)",
        mobileClipPolygonTopLeft:
          "polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 23%)",
        webClipPolygonTopLeft:
          "polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 23%)",
        mobileClipPolygonTopRight:
          "polygon(0% 0%, 88% 0%, 100% 12%, 100% 100%, 0% 100%)",
        mobilePYPClipPolygonTopRight:
          "polygon(0% 0%, 86% 0%, 100% 100px, 100% 100%, 0% 100%)",
        webClipPolygonTopRight:
          "polygon(0% 0%, 92% 0%, 100% 25%, 100% 100%, 0% 100%)",
        webClipPolygonTopRightSmallCard:
          "polygon(0% 0%, 85% 0%, 100% 40%, 100% 100%, 0% 100%)",
        mobileClipPolygonBottomRight:
          "polygon(0% 0%, 100% 0%, 100% 80%, 80% 100%, 0% 100%)",
        mobileClipPolygonBottomRightLessHeight:
          "polygon(0% 0%, 100% 0%, 100% 65%, 95% 100%, 0% 100%)",
        webClipPolygonBottomRight:
          "polygon(0% 0%, 100% 0%, 100% 70%, 90% 100%, 0% 100%)",
      },
      fontFamily: {
        spaceGrotesk: ["Space Grotesk"],
        openSans: ["Open Sans"],
        ibmPlex: ["IBM Plex Sans"],
        inter: ['"Inter"', "sans-serif"],
        space: ['"Space Grotesk"', "sans-serif"],
      },
      screens: {
        mobile: "420px",
        mid: "1240px",
        xxl: "1440px",
        "3xl": "1800px",
        card: "486px",
      },
      letterSpacing: {
        "1.4": "0.0875em",
        "1.5": "0.09375em",
      },
      height: {
        18: "1.125rem",
      },
      colors: {
        bankerColor: "#262626",
        border: "hsl(var(--border))",
        "input-autofill-bg": "#fff",
        input: "hsl(var(--input))",
        ring: "hsl(var(--ring))",
        background: "hsl(var(--background))",
        foreground: "hsl(var(--foreground))",
        primary: {
          DEFAULT: "hsl(var(--primary))",
          foreground: "hsl(var(--primary-foreground))",
        },
        secondary: {
          DEFAULT: "hsl(var(--secondary))",
          foreground: "hsl(var(--secondary-foreground))",
        },
        destructive: {
          DEFAULT: "hsl(var(--destructive))",
          foreground: "hsl(var(--destructive-foreground))",
        },
        muted: {
          DEFAULT: "hsl(var(--muted))",
          foreground: "hsl(var(--muted-foreground))",
        },
        accent: {
          DEFAULT: "hsl(var(--accent))",
          foreground: "hsl(var(--accent-foreground))",
        },
        popover: {
          DEFAULT: "hsl(var(--popover))",
          foreground: "hsl(var(--popover-foreground))",
        },
        card: {
          DEFAULT: "hsl(var(--card))",
          foreground: "hsl(var(--card-foreground))",
        },
        neutral: {
          50: "#fafafa",
          200: "#e6e6e6",
          300: "#d9d9d9",
          400: "#c8c8c8",
          500: "#adadad",
        },
        brand: {
          orange: {
            DEFAULT: "#FF752C",
            dark: "#e55a00",
          },
          lightBlue: "#F1EAFF",
          bgBlack: "#262626",
          bgWhite: "#FFFFFF",
          bgGrey: "#F4F4F4",
          bgSuccessGreen: "#4DBB3E",
          bgLightGrey: "#F8F8F8",
          borderGreyTwo: "#F2F2F2",
          textBlack: "#262626",
          textDarkBlack: "#141414",
          textGrey: "#666666",
          textLightGrey: "#7D7D7D",
          textWhite: "#FFFFFF",
          lightPink: "#FAF7FA",
          lightOrange: "#FEECE6",
          headingBlue: "#5D5FEF",
          borderGrey: "#A8A8A8",
          borderLightGray: "#D1D0D0",
          textRed: "#FF0000",
          primaryAction: "#f97316",
          primaryActionHover: "#f97416ac",
          cardBgVariant1: "#f9fafb",
          primaryTextDarkGrey: "#1f2937",
          secondaryTextLabelGrey: "#6b7280",
          bordersDividerLightGrey: "#e5e7eb",
          rootBackgroundVariant1: "#f4f6f9",
          darkBlueVariant1: "#0f2a44",
        },
        sidebar: {
          DEFAULT: "hsl(var(--sidebar-background))",
          foreground: "hsl(var(--sidebar-foreground))",
          primary: "hsl(var(--sidebar-primary))",
          "primary-foreground": "hsl(var(--sidebar-primary-foreground))",
          accent: "hsl(var(--sidebar-accent))",
          "accent-foreground": "hsl(var(--sidebar-accent-foreground))",
          border: "hsl(var(--sidebar-border))",
          ring: "hsl(var(--sidebar-ring))",
        },
      },
      borderRadius: {
        lg: "var(--radius)",
        md: "calc(var(--radius) - 2px)",
        sm: "calc(var(--radius) - 4px)",
        10: "10px",
      },
      keyframes: {
        "accordion-down": {
          from: {
            height: "0",
          },
          to: {
            height: "var(--radix-accordion-content-height)",
          },
        },
        "accordion-up": {
          from: {
            height: "var(--radix-accordion-content-height)",
          },
          to: {
            height: "0",
          },
        },
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out",
      },
      fontSize: {
        "web-h1": [
          "4rem",
          {
            lineHeight: "1.2",
          },
        ],
        "web-h2": [
          "48px",
          {
            lineHeight: "1.2",
          },
        ],
        "web-h3": [
          "28px",
          {
            lineHeight: "1.2",
          },
        ],
        "web-subheading": [
          "18px",
          {
            lineHeight: "1.2",
          },
        ],
        "web-body-lg": [
          "16px",
          {
            lineHeight: "1.5",
          },
        ],
        "web-body-md": [
          "14px",
          {
            lineHeight: "1.5",
          },
        ],
        "web-body-sm": [
          "12px",
          {
            lineHeight: "1rem",
          },
        ],
        "mobile-h1": [
          "30px",
          {
            lineHeight: "1.2",
          },
        ],
        "mobile-h2": [
          "28px",
          {
            lineHeight: "1.2",
          },
        ],
        "mobile-h3": [
          "24px",
          {
            lineHeight: "1.2",
          },
        ],
        "mobile-subheading": [
          "18px",
          {
            lineHeight: "1.2",
          },
        ],
        "mobile-body-lg": [
          "16px",
          {
            lineHeight: "1.5",
          },
        ],
        "mobile-body-md": [
          "14px",
          {
            lineHeight: "1.5",
          },
        ],
        "mobile-body-sm": [
          "12px",
          {
            lineHeight: "1.5",
          },
        ],
        "mobile-body-xsm": [
          "10px",
          {
            lineHeight: "13px",
          },
        ],
        "11": "0.6875rem",
        "15": "0.9375rem",
      },
      padding: {
        customPadding: "6.25rem",
        customPaddingMobile: "1rem",
        18: "1.125rem",
      },
      backgroundImage: {
        "custom-gradient":
          "linear-gradient(90deg, #BFBFBF 0%, rgba(161, 160, 160, 0) 63.8%)",
        "custom-card-grey":
          "linear-gradient(90deg, #F7F7F7 0%, rgba(255, 255, 255, 0) 100%)",
        "linear-purple": "linear-gradient(90deg, #F1EAFF 0%, #FFFFFF 100%)",
        "linear-green-fade":
          "linear-gradient(90deg, #EFFFED 0%, rgba(248, 248, 248, 0) 100%)",
      },
      boxShadow: {
        "hero-image":
          "0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px 0px rgba(0, 0, 0, 0.30)",
        "card-shadow": "0 2px 8px rgba(0, 0, 0, .06)",
        "deep-xl": "0 30px 80px rgb(0 0 0 / 0.30)",
        "inset-subtle": "inset 0 1px 2px rgb(0 0 0 / 0.04)",
      },
    },
  },
  plugins: [tailwindcssAnimate, require("tailwind-clip-path")],
};

export default uiTailwindConfig;
